import React from 'react';
import CommonButton from "../../../../components/ui/CommonButton/CommonButton.jsx";
import { NON_CUSTODIAL_CONNECTION_STATUS } from '../../../../constants/wallet.constants';
import { WHITELIST_STATUS } from '../buySellTab.constants';
import { wrapDisabledActionTooltip } from "../buySellTab.utils.jsx";
const PlaceOrderPrimaryAction = ({
  isWalletReady,
  linkedWalletsLoading,
  isPairWhitelistFetching,
  isSelectWalletBlockedByWhitelist,
  selectWalletWhitelistBlockReason,
  onOpenWalletModal,
  isNonCustodialBlocked,
  nonCustodialConnectionStatus,
  selectedTradeWallet,
  onConnectWallet,
  isApprovingAllowance,
  approvingAssetLabel,
  isSpotTradeWhitelistRoute,
  isWalletWhitelistFetching,
  walletWhitelistStatus,
  buyActionLoading,
  isSpotMode,
  isWhitelistSubscribing,
  whitelistCoin,
  onSubscribeWhitelist,
  whitelistWalletErrorMessage,
  selectedSide,
  isPerpetualMode,
  leverage,
  otherCurrencyLabel,
  getPrimaryButtonTitle,
  sendOrderDisabled,
  sendOrderDisabledReason
}) => {
  if (!isWalletReady) {
    const selectWalletButton = <CommonButton title={linkedWalletsLoading || isPairWhitelistFetching ? 'Please Wait...' : 'Select Wallet'} disabled={linkedWalletsLoading || isPairWhitelistFetching || isSelectWalletBlockedByWhitelist} type="button" className="w-100 " onClick={onOpenWalletModal} />;
    return wrapDisabledActionTooltip(selectWalletButton, selectWalletWhitelistBlockReason, 'select-wallet-whitelist-block');
  }
  if (isNonCustodialBlocked) {
    const title = nonCustodialConnectionStatus === NON_CUSTODIAL_CONNECTION_STATUS.MISMATCH ? 'Wrong Wallet Connected' : nonCustodialConnectionStatus === NON_CUSTODIAL_CONNECTION_STATUS.CONNECTING ? 'Connecting Wallet...' : 'Connect Wallet';
    const connectWalletButton = <CommonButton title={title} disabled={nonCustodialConnectionStatus === NON_CUSTODIAL_CONNECTION_STATUS.CONNECTING} type="button" className="w-100 " onClick={() => onConnectWallet(selectedTradeWallet)} />;
    return wrapDisabledActionTooltip(connectWalletButton, sendOrderDisabledReason || 'Connect your linked wallet in MetaMask to place an order.', 'connect-wallet-block');
  }
  if (isApprovingAllowance) {
    return wrapDisabledActionTooltip(<CommonButton title={approvingAssetLabel ? `Approving ${approvingAssetLabel}...` : 'Approving Token...'} disabled type="button" className="w-100 " />, sendOrderDisabledReason || 'Token approval is in progress. Please wait.', 'approving-allowance');
  }
  if (isSpotTradeWhitelistRoute && (isWalletWhitelistFetching || walletWhitelistStatus == null)) {
    return wrapDisabledActionTooltip(<CommonButton title="Please Wait..." disabled type="button" className="w-100 " />, 'Checking wallet whitelist status. Please wait.', 'wallet-whitelist-loading');
  }
  if (buyActionLoading) {
    return wrapDisabledActionTooltip(<CommonButton title="Please Wait..." disabled type="button" className="w-100 " />, 'Checking whitelist status. Please wait.', 'buy-whitelist-loading');
  }
  if (isSpotMode && isSpotTradeWhitelistRoute && walletWhitelistStatus === WHITELIST_STATUS.NOT_SUBMITTED) {
    return <CommonButton title={isWhitelistSubscribing ? 'Please Wait...' : 'Subscribe'} disabled={isWhitelistSubscribing || !whitelistCoin} type="button" className="w-100 " onClick={onSubscribeWhitelist} />;
  }
  if (isSpotMode && isSpotTradeWhitelistRoute && walletWhitelistStatus === WHITELIST_STATUS.SUBMITTED) {
    return wrapDisabledActionTooltip(<CommonButton title="Submitted for Approval" disabled type="button" className="w-100 " />, 'Subscription request submitted successfully. Waiting for STO approval.', 'whitelist-submitted-approval');
  }
  if (whitelistWalletErrorMessage) {
    return wrapDisabledActionTooltip(<CommonButton title={getPrimaryButtonTitle()} disabled type="submit" className={`w-100 ${selectedSide === 0 ? 'bg-green' : 'bg-red'}`} />, whitelistWalletErrorMessage, 'wallet-whitelist-error');
  }
  const sideBtnClass = selectedSide === 0 ? 'bg-green' : 'bg-red';
  const button = <CommonButton title={getPrimaryButtonTitle()} disabled={sendOrderDisabled} type="submit" className={`w-100 ${sideBtnClass}`} />;
  const disabledActionTooltip = sendOrderDisabled ? sendOrderDisabledReason || 'Unable to place order right now.' : '';
  return wrapDisabledActionTooltip(button, disabledActionTooltip);
};
export default PlaceOrderPrimaryAction;